import { render, staticRenderFns } from "./MyQuotes.vue?vue&type=template&id=0453fa30&scoped=true&"
import script from "./MyQuotes.vue?vue&type=script&lang=js&"
export * from "./MyQuotes.vue?vue&type=script&lang=js&"
import style0 from "./MyQuotes.vue?vue&type=style&index=0&id=0453fa30&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0453fa30",
  null
  
)

export default component.exports